import powerpoint from './components/images/powerpoint.png'
import pdf from './components/images/pdf.png'
import * as aserver from './APIClient';

export function validateEmail(email) {
  return email.match(
    // eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );  
}

export function assessmentCodeToName(code) {
  const map = JSON.parse(localStorage.getItem('assessmentNames'));
  if (!map)
    return(code);
  if (!map[code])
    return(code);
  return(map[code]);
}

export function teamCodeToName(code) {
  const map = JSON.parse(localStorage.getItem('teamNames'));
  if (!map)
    return(code);
  if (!map[code])
    return(code);
  return(map[code]);
}

export function filterForNotInvited(record){
  if(record.userInvite===null && record.userRegistration=== null && record.coachWrappedUp !== 1){
      return record
    }
}
export function filterForInvitedButNotRegistered(record){
  if(record.userInvite && record.userRegistration=== null && record.coachWrappedUp !== 1){
        return record
      }
}
export function filterForRegisteredButNotCompleted(record){
  if(record.userRegistration && record.userCompletion === null && record.coachWrappedUp !== 1){
        return record
      }
}
export function filterForCompletedButReportNotAvailable(record){
  //The ennea and enngream is spelt different on the different pages thats why filter is broken
  if(record.userCompletion && record.marked === false && (record.assessmentType !== "Enneagram") && record.coachWrappedUp !== 1){
    return record
  }
}
export function filterForCompletedButNotSent(record){
  if(record.userReport === null && record.userCompletion && record.coachWrappedUp !== 1){
    return record
  }
}

export function filterForSCO(record){
  if(record.fromAnotherCoach && record.coachWrappedUp !== 1){
    return record
  }
}

export function filterWrapped(record){
  if(record.coachWrappedUp === 1){
    return record
  }
}

export function filterUnwrapped(record){
  if(record.coachWrappedUp === 0){
    return record
  }
}

export function filterForAllRecords(record){
  return record
}

export const filterButtons=[
  {id: 'notInvitedYet', caption: 'Not invited yet', filterFunction:filterForNotInvited},
  {id: 'invitedNotStarted', caption: 'Invited, not started', filterFunction:filterForInvitedButNotRegistered},
  {id: 'startedIncomplete',caption: 'Started, incomplete', filterFunction:filterForRegisteredButNotCompleted},
  {id: 'completeInMarking',caption: 'Complete, in marking', filterFunction:filterForCompletedButReportNotAvailable},
  {id: 'completeSendReport',caption: 'Complete, send report ', filterFunction:filterForCompletedButNotSent},
  {id: 'allRecords', caption: 'Show all', filterFunction:filterForAllRecords},
  {id: 'filterSCO',caption: `Received SCOs `, filterFunction:filterForSCO},
  {id: 'wrapped',caption: `Wrapped `, filterFunction:filterWrapped},
  {id: 'unwrapped',caption: `Unwrapped `, filterFunction:filterUnwrapped},
];

async function downloadTeamReport(selectedRecord, formatOfReport, component, aserver) {
  component.setState({
    openBackdrop:true
  });
  component.toastMessage("Downloading...", "success")
  let downloadResponse = await aserver.download(`api/v2/teams/${selectedRecord}/downloadReport/${formatOfReport}`);
  if(downloadResponse.status !== 200){
    component.openAlertModal("Failed", downloadResponse.data.error.info)
    component.setState({
      openBackdrop:false
    });
  }else{
    component.setState({
      openBackdrop:false
    });
  }
}

export function capitalize(s) {
  return(s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());
}

function teamMemberEmailOf(record) {
  return record.clientEmail || record.userEmail || '';
}

// Returns one entry per email that would appear more than once in the team report,
// counting both assessments already on the team and newly selected ones.
export function findDuplicateTeamMemberEmails(selectedAssessments, existingMembers = []) {
  const normalise = email => (email || '').trim().toLowerCase();

  const existingCountByEmail = new Map();
  for (const member of (existingMembers || [])) {
    const email = normalise(teamMemberEmailOf(member));
    if (!email)
      continue;
    existingCountByEmail.set(email, (existingCountByEmail.get(email) || 0) + 1);
  }

  const selectedByEmail = new Map();
  for (const assessment of (selectedAssessments || [])) {
    const displayEmail = teamMemberEmailOf(assessment);
    const email = normalise(displayEmail);
    if (!email)
      continue;
    if (!selectedByEmail.has(email))
      selectedByEmail.set(email, { displayEmail, count: 0 });
    selectedByEmail.get(email).count++;
  }

  const duplicates = [];
  for (const [email, { displayEmail, count }] of selectedByEmail) {
    const existingCount = existingCountByEmail.get(email) || 0;
    if (existingCount === 0 && count < 2)
      continue;
    duplicates.push({ email: displayEmail });
  }
  return duplicates;
}

export function duplicateTeamMemberEmailMessage(duplicates) {
  // Backward compatibility: still accept a plain array of email strings.
  const emails = (duplicates.length && typeof duplicates[0] === 'string')
    ? duplicates
    : duplicates.map(dup => dup.email);

  const intro = 'A team report can only include one assessment per person.';

  if (emails.length === 1)
    return `${intro} Adding the selected assessments to this team will result in ${emails[0]} having more than one assessment included.`;

  return `${intro} Adding the selected assessments to this team will result in ${emails.length} people having more than one assessment included: ${emails.join(', ')}`;
}

export async function addTeamMembers(component, teamId, memberUUIDs, refreshTable) {
  try {
    const results = await aserver.post(`api/v3/teams/${teamId}/addMembers`, {
      memberUUIDs: memberUUIDs
    });
    console.log(results);
    const added = results.data.added;
    if (added === memberUUIDs.length) {
      component.toastMessage(`Success! All ${added} member(s) have been added.`, "success")
      component.closeModal()
      if (refreshTable)
        component.refreshTable()
    } else if ((added < memberUUIDs.length) && (added > 0)) {
      component.openAlertModal("Please note", `You've added ${added} out of ${memberUUIDs.length}. The other assessments are already part of this team.`)
      if (refreshTable)
        component.refreshTable()
    } else {
      component.openWarningModal("Please note", "All selected assessments are already part of this team.")
    }
  } catch (err) {
    console.log(err);
    component.openAlertModal("Please note", `Unexpected error while trying to add assessments to the team.`)
  }
}


export function getTeamReportDownloadLinks(component, record, aserver) {
  function reportLink(format, formatName) {
    return(<div key={Math.random()}><u className="downloadTeamReport" onClick={()=>downloadTeamReport(record.uuid, format, component, aserver)}>{formatName}</u><br></br></div>)
  }
  var reportLinks = [];
  if (record.offerReportPDF)
    reportLinks.push(reportLink('pdf', <img className='teamReportDownloadImage' alt="pdf" src={pdf}></img>));
  if (record.offerReportPPTX)
    reportLinks.push(reportLink('pptx', <img className='teamReportDownloadImage' alt="powerpoint" src={powerpoint}></img>));
  if (record.isReportAvailable){
    return(<div className='teamReportDownloadDiv'>
      {reportLinks}
    </div>);
  } else {
    if (record.reportRequested)
      return(<p>Not yet available</p>);
    else
      return(<p>-</p>);
  }
}

export const HandlePasswordEditChange = (event,component, password, confirmPassword, allowBlank) =>{ 
  if (event.target.id === "password")
    password = event.target.value;
  if (event.target.id === "confirmPassword") 
    confirmPassword = event.target.value;
  let doesPasswordsMatch = CheckIfPasswordsMatch(password, confirmPassword, component);
  let isPasswordStrong = CheckPasswordStrength(password,component);
  let passwordGoodToGo = (doesPasswordsMatch && isPasswordStrong);
  if ((allowBlank) && (password === "") && (confirmPassword === "")){
    passwordGoodToGo = true
  }
  component.setState({
    [event.target.name]: event.target.value,
    passwordGoodToGo : passwordGoodToGo
  });
}

const CheckPasswordStrength = (password, component)=> {
  if(password ==="") {
    component.setState({
      success:[],
      error:[],
      showCurrentPassword:false
    })
  }
  var owasp = require('owasp-password-strength-test');
  var result = owasp.test(password);
  if (!result.strong && password!=="") {
    component.setState({
      error: result.errors,
      success:[],
      showCurrentPassword:true
    });
    return(false);
  }else if(password!==""){
    component.setState({
      error: [],
      success:["Password secure"],
      showCurrentPassword:true
    })
    return(true);
  }
};

const CheckIfPasswordsMatch = (password, confirmPassword, component)=>{
  if(confirmPassword===""){
    component.setState({
      confirmPasswordSuccess:[],
      confirmPasswordError:[],
    })
  }
  if((password !== confirmPassword)&&(confirmPassword!=="")) {
    component.setState({
      confirmPasswordError: ["Passwords don't yet match"],
      confirmPasswordSuccess:[],
      showCurrentPassword:true
    });
    return(false);
  }else if((confirmPassword!=="")&&(password===confirmPassword)){
    component.setState({
    confirmPasswordError: [],
    confirmPasswordSuccess:["Passwords match"]
  })
  return(true);
  }
}


export const PasswordDiv = ({ component }) => {
return (<>
  <p style={{textAlign:"left"}}>Your password must be at least 10 characters in length and meet certain requirements,
                               or it can be a simpler passphrase of 20 characters or longer.</p>
  <div className="passwordErrors">
    <ul>
      {component.state.error.map(info => (
        <li key={info}>{info}</li>
      ))}
    </ul>
  </div>
  <div className="passwordSuccess">
    <ul>
      {component.state.success.map(info => (
        <li key={info}>{info}</li>
      ))}
    </ul>
  </div>
  <div className="passwordErrors">
    <ul>
      {component.state.confirmPasswordError.map(info => (
        <li key={info}>{info}</li>
      ))}
    </ul>
  </div>
  <div className="passwordSuccess">
    <ul>
      {component.state.confirmPasswordSuccess.map(infos => (
        <li key={infos}>{infos}</li>
      ))}
    </ul>
  </div>
  </>
  );
};
              

var timerStartTime = 0;

export function timerStart() {
  timerStartTime = performance.now();
}

export function timerShow(message) {
  console.log(`TIMER ${message}`,(performance.now()-timerStartTime))
  timerStartTime = performance.now();
}

export const writeCoachDetailsToLocalStorage  =(result, impersonator)=>{
  localStorage.setItem("Id", result.data.coach.uuid );
  localStorage.setItem("impersonator", impersonator);
  localStorage.setItem("hasMaturityAccreditation", result.data.coach.isAccreditedLevel2 ? "1" : "0")
  localStorage.setItem("singleNotification", result.data.coach.sendSingleAssessmentNotifications);
  localStorage.setItem("bulkNotification", result.data.coach.sendBulkAssessmentNotifications)
  localStorage.setItem("isBeingAssisted", result.data.coach.isBeingAssisted)
  if( result.data.coach.isBeingAssisted){
    localStorage.setItem("assistantEmail", result.data.coach.assistant.email)
    localStorage.setItem("assistantName", result.data.coach.assistant.name)
  }
}

